export default {
  Language: 'English',
  system: {
    homePage: {
      login: 'login',
      register: 'register',
    },
    headerMenu: {
      HomePage: "Home Page",
      ScientificData: "Scientific Data",
      PDSDataSet: "PDS DataSet",
      LunarSample: "Planetary Database ",
      WebGis: "WebGis",
      Moon: "Moon",
      Mars: "Mars",
      Planet: "Planet",
      SampleMoon: "Lunar Samples",
      SampleAsteroid: 'Asteroids Samples',
      ResourceTools: "Resource Tools",
      AboutUs: "About Us",
      PopularScience: "Popular Science",
      PlanetaryDatabaseName: "Planetary Database",
      extraterrestrial: "Extraterrestrial Samples",
    },
    infoData: {
      lastNew: "Recent News",
      more: "more",
      Roam: "Moon",
      Lunar: "Lunar",
      MoonandPlanets: "Moon and Planets",
      PopularScience: "Popular Science",
      RecentNews: "Recent News",
      DataRelease: "Data Release",
      TasksIntroduction: "Tasks Introduction",
      OngoingNews: "Ongoing News",
      LatestProduct: "Latest Product",
      NoticeandAnnouncement: "Noticeand Announcement",
      Other: "Other",
      ReleaseTime: "ReleaseTime",
      PageViews: "PageViews"
    },
    footData: {
      Name: "National Astronomical Observatories of China",
      ContactUs: "Contact Us",
      RecordNumber: "Record Number",
      WenbaoNetworkSecurityFilingNumber: "Wenbao Network Security Filing Number"
    }
  }
};
